import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Loader from "./lib/Loader";
import translationService from "./lib/translationService";
import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";

// The API is reached through the same-origin /api proxy, which adds the
// Authorization header server-side (see docker/default.conf). Keeping the
// token out of the bundle also keeps it out of the browser's reach.
translationService.changeLanguage("en");

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense
        fallback={
          <div>
            <Loader />
          </div>
        }
      >
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
